import { render } from "./PosterSlider.vue?vue&type=template&id=476ee7f4"
import script from "./PosterSlider.vue?vue&type=script&lang=js"
export * from "./PosterSlider.vue?vue&type=script&lang=js"

import "./PosterSlider.vue?vue&type=style&index=0&id=476ee7f4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__